module.exports = __webpack_public_path__ + "img/withdrawal-active.8f96a44c.svg";